
import secureLocalStorage from "react-secure-storage";

export default function DateFormatter(value) {
	try {

		const myDate = new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
		return myDate
	} catch (e) {
		
	}
}
export function DoMaskValue(value, num = 4, maskCharacter = '*') {
	try {
		const newValue = value.toString();
		if (newValue.length < num * 2) {
			return newValue
		}

		const maskStart = Math.floor((newValue.length - num) / 2);
		const maskEnd = maskStart + num;

		const maskedString = newValue.slice(0, maskStart) + Array(num).fill(maskCharacter).join('') + newValue.slice(maskEnd);
		return maskedString;

	} catch (error) {

	}

}

export const currencyconverter = (value, currency) => {

    let countryCurrency = secureLocalStorage.getItem('localCurrency');
    if((!countryCurrency) || (countryCurrency === undefined) || (countryCurrency === null) || (countryCurrency === "undefined")){
        countryCurrency = currency ? currency : 'KES'
    }
    return new Intl.NumberFormat('en-Us', {
         style:'currency',
         currency:countryCurrency
     }).format(value)
    
}

export const getColorCode = (color) => {
	if (typeof color !== "string") return null;
	const originalColor = color.trim();
	color = color.trim().toUpperCase();

	const colorMap = {
		// Existing colors
		"JUNGLE GREEN": "#048243",
		"SKY BLUE":"#87CEEB",
		"DARK GREY":"#A9A9A9",
		"NAVY BLUE":"#000080",
		"WHITE GREY":"#F5F5F5",

		// Common colors
		"BLACK": "#000000",
		"WHITE": "#FFFFFF",
		"RED": "#FF0000",
		"GREEN": "#008000",
		"BLUE": "#0000FF",
		"YELLOW": "#FFFF00",
		"ORANGE": "#FFA500",
		"PURPLE": "#800080",
		"PINK": "#FFC0CB",
		"BROWN": "#A52A2A",
		"GREY": "#808080",
		"GRAY": "#808080",
		"LIME": "#00FF00",
		"CYAN": "#00FFFF",
		"MAGENTA": "#FF00FF",
		"MAROON": "#800000",
		"OLIVE": "#808000",
		"NAVY": "#000080",
		"TEAL": "#008080",
		"SILVER": "#C0C0C0",
		"GOLD": "#FFD700",
		"BEIGE": "#F5F5DC",
		"IVORY": "#FFFFF0",
		"KHAKI": "#F0E68C",
		"LAVENDER": "#E6E6FA",
		"MINT": "#98FB98",
		"PEACH": "#FFCBA4",
		"ROSE": "#FF66CC",
		"SALMON": "#FA8072",
		"TURQUOISE": "#40E0D0",
		"VIOLET": "#8A2BE2",

		// Light/Dark variations
		"LIGHT BLUE": "#ADD8E6",
		"DARK BLUE": "#00008B",
		"LIGHT GREEN": "#90EE90",
		"DARK GREEN": "#006400",
		"LIGHT GREY": "#D3D3D3",
		"LIGHT GRAY": "#D3D3D3",
		"DARK GRAY": "#A9A9A9",
		"LIGHT PINK": "#FFB6C1",
		"DARK RED": "#8B0000",
		"LIGHT YELLOW": "#FFFFE0",
		"DARK PURPLE": "#4B0082",
	};

	// Check color map first
	if (colorMap[color]) return colorMap[color];

	// If it's already a hex code, return it
	if (/^#([0-9A-F]{3}){1,2}$/i.test(originalColor)) {
		return originalColor.toUpperCase();
	}

	// Try using canvas to resolve CSS color names
	try {
		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");

		ctx.fillStyle = originalColor.toLowerCase();
		const computedColor = ctx.fillStyle;

		// Canvas returns #000000 for invalid colors, so check if it's a valid conversion
		if ((computedColor && computedColor !== "#000000") || originalColor.toLowerCase() === "black") {
			
			return computedColor.toUpperCase();
		}else{
	
			return originalColor.toUpperCase();
		}
	} catch (e) {
		console.warn("Canvas color resolution failed:", e);
	}

	// Final fallback - return the original color for CSS compatibility
	return originalColor;
};

  